import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useIsMobile } from '../../hooks/useIsMobile';

/** L'id del posto dove atterrano, sul telefono: lo stampa la Topbar. */
export const PAGE_ACTIONS_SLOT = 'm-hd-slot';

/**
 * I COMANDI SECONDARI DI UNA PAGINA, e dove stanno sul telefono.
 *
 * Sul computer questo componente non fa niente: rende un `div` con la classe
 * che gli passi, cioè esattamente il contenitore che c'era prima. Sotto i 768px
 * invece porta i suoi figli dentro la barra in alto, accanto alla ricerca.
 *
 * Perché. L'intestazione di una pagina di elenco, sul telefono, non ha più il
 * titolo (lo dice la barra) né il sottotitolo: restano i comandi, e da soli si
 * prendono una riga intera di 60px sopra il primo dato. Su /admin erano due
 * bottoni — "Anni scorsi" e i tre puntini — e 348px vuoti accanto. In alto,
 * dove la barra ha spazio libero fra il titolo e la lente, quella riga non si
 * paga: sono gli stessi comandi, zero pixel di pagina.
 *
 * ⚠️ QUI NON VA L'AZIONE PRINCIPALE. La regola della barra in alto non cambia
 * (mobile.css §C): in cima si arriva col pollice solo cambiando presa, quindi
 * lassù ci vanno i comandi che si usano di rado — un filtro di periodo, uno
 * storico, il menu dei tre puntini. Creare, salvare, confermare restano in
 * basso, nella `.m-actionbar`.
 *
 * Il portale invece di spostare il nodo a mano: React deve continuare a
 * possedere quei figli (stato dei menu compreso), e muovere un elemento che
 * React tiene in conto è il modo classico per farsi un `removeChild` fallito
 * al cambio di pagina.
 */
export function PageActions({ children, className }: { children: ReactNode; className?: string }) {
  const isMobile = useIsMobile();
  // Lo slot si cerca in un effetto, non durante il render: al primo giro la
  // Topbar è nello stesso commit e il nodo nel DOM non c'è ancora.
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setSlot(isMobile ? document.getElementById(PAGE_ACTIONS_SLOT) : null);
  }, [isMobile]);

  if (!isMobile) return <div className={className}>{children}</div>;
  if (!slot) return null;
  return createPortal(<div className="m-hd-actions">{children}</div>, slot);
}
